import Image from "next/image";
import UilSpinner from "@/public/assets/loaders/spinner.svg";

const UilCircularLoader = ({ size = 48 }) => {
  return (
    <Image
      src={UilSpinner}
      alt="Loading..."
      width={size}
      height={size}
      className="uil-spinner"
    />
  );
};
export default UilCircularLoader;
